'use client';
import { useEffect } from 'react';
import { classes } from './utils';

export default function NotFound() {
  useEffect(() => {
    // @ts-ignore
    window.location = '/dashboard/overview';
  }, []);

  return <div className={classes.notFound}>Redirecting...</div>;
}
